var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4681 0C11.8206 0 12.1064 0.285776 12.1064 0.638298C12.1064 0.99082 11.8206 1.2766 11.4681 1.2766H5.59576C5.24323 1.2766 4.95746 0.99082 4.95746 0.638298C4.95746 0.285776 5.24323 0 5.59576 0H11.4681Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40425 10.7236C8.75678 10.7236 9.04255 11.0094 9.04255 11.3619C9.04255 11.7145 8.75678 12.0002 8.40425 12.0002H2.53191C2.17939 12.0002 1.89362 11.7145 1.89362 11.3619C1.89362 11.0094 2.17939 10.7236 2.53191 10.7236H8.40425Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4894 5.36182C12.8419 5.36182 13.1277 5.64759 13.1277 6.00011C13.1277 6.35264 12.8419 6.63841 12.4894 6.63841H1.51064C1.15812 6.63841 0.872345 6.35264 0.872345 6.00011C0.872345 5.64759 1.15812 5.36182 1.51064 5.36182H12.4894Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.23e699f7789454d4c41891ebfe6fa99b.svg";
export { ForwardRef as ReactComponent };